import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { RefreshCw, QrCode } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export const PixBadge = ({ sale }) => {
  if (!sale.pix_status) return null;
  const paid = sale.pix_status === 'pago';
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold inline-flex items-center gap-1 ${paid ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-800'}`}
      title={paid ? `PIX confirmado${sale.pix_paid_at ? ` em ${new Date(sale.pix_paid_at).toLocaleString('pt-BR')}` : ''}` : 'Cobrança Sicoob ainda sem confirmação'} data-testid={`pix-badge-${sale.id}`}>
      <QrCode size={10} /> PIX {paid ? 'pago' : 'pendente'}{sale.pix_amount ? ` R$ ${Number(sale.pix_amount).toFixed(2)}` : ''}
    </span>
  );
};

// Botão por venda: reconsulta a cobrança no Sicoob
export const PixRecheckButton = ({ sale, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if (sale.pix_status !== 'pendente' || !sale.pix_txid) return null;
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/pix/sicoob/charge/${sale.pix_txid}?refresh=1`, cfg);
      if (r.data.paid) toast.success(`PIX da venda #${sale.sale_number} confirmado!`); else toast.info(`Venda #${sale.sale_number}: cobrança ${r.data.status || 'ainda pendente'}`);
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Falha ao consultar o Sicoob'); } finally { setBusy(false); }
  };
  return (
    <button onClick={go} disabled={busy} className="text-xs text-amber-800 hover:underline inline-flex items-center gap-0.5" title="Reconsultar esta cobrança no Sicoob" data-testid={`pix-recheck-${sale.id}`}>
      <RefreshCw size={12} className={busy ? 'animate-spin' : ''} /> Reconsultar
    </button>
  );
};

// Botão global (filtro PIX pendente): concilia todas as cobranças abertas dos últimos dias
export const PixReconcileButton = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/pix/sicoob/reconcile?days=7`, {}, cfg);
      const d = r.data;
      if (d.confirmed.length) toast.success(`${d.confirmed.length} PIX confirmado(s) de ${d.checked} verificado(s)`);
      else toast.info(d.checked ? `${d.checked} cobrança(s) verificada(s) — nenhuma paga ainda` : 'Nenhuma cobrança PIX pendente nos últimos 7 dias');
      if (d.errors?.length) toast.error(`${d.errors.length} cobrança(s) com erro na consulta`);
      onDone?.(d);
    } catch (e) { toast.error(e.response?.data?.detail || 'Falha na conciliação'); } finally { setBusy(false); }
  };
  return (
    <Button onClick={go} disabled={busy} variant="outline" className="border-amber-500 text-amber-800 hover:bg-amber-50" data-testid="pix-reconcile-btn">
      <RefreshCw size={16} className={`mr-2 ${busy ? 'animate-spin' : ''}`} /> {busy ? 'Consultando Sicoob…' : 'Reconsultar Sicoob (pendentes)'}
    </Button>
  );
};
